import React, { useState } from 'react'
import PropTypes from 'prop-types'

import createPaginatedListLoadMoreQuery from '@/query/widget/paginated-list-widget-load-more'

import Prose from '../../Primitive/Prose'
import Stack from '../../Primitive/Stack'
import ButtonStandard from '../../Primitive/ButtonStandard'
import TextAlign from '../../Primitive/TextAlign'

import styles from './PaginatedList.module.scss'

const PaginatedListWidget = ({ itemsPerPage, items, totalItems }) => {
  const [results, setResults] = useState(items)
  const [pageNum, setPageNum] = useState(2)
  const [canLoadMore, setCanLoadMore] = useState(totalItems > itemsPerPage)

  const onNextClick = async () => {
    const url = window.location.origin + '/graphql'
    const query = createPaginatedListLoadMoreQuery()
    const vars = {
      widgetType: 'paginatedList',
      page: pageNum,
      url: window.location.href
    }
    const response = await fetch(url, {
      headers: { 'content-type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({ query, variables: vars })
    })
    const newResults = await response.json()
    const updatedResults = [
      ...results,
      ...newResults.data.paginatedWidget.items
    ]
    setResults(updatedResults)
    setPageNum(pageNum + 1)
    setCanLoadMore(updatedResults.length < totalItems)
  }

  return (
    <>
      {results &&
        results.length > 0 &&
        results.map((item, i) => {
          const count = totalItems - i
          const titleHtml = `<h5>${count.toString().padStart(2, '0')}: ${
            item.title
          }`
          return (
            <Stack key={i}>
              <Prose className={styles.ListItem}>
                <Prose dangerousHtml={`<h5>${titleHtml}</h5>${item.text}`} />
                {item.images.hero_landscape_668 && (
                  <img
                    loading="lazy"
                    alt={`Item--${i}`}
                    src={item.images?.hero_landscape_668?.[0]?.url}
                  />
                )}
              </Prose>
            </Stack>
          )
        })}

      {canLoadMore && (
        <TextAlign center>
          <ButtonStandard
            className={styles.Button}
            primary
            outline
            onClick={onNextClick}
          >
            Next {itemsPerPage}
          </ButtonStandard>
        </TextAlign>
      )}
    </>
  )
}

PaginatedListWidget.propTypes = {
  items: PropTypes.array,
  itemsPerPage: PropTypes.string,
  totalItems: PropTypes.number
}

export default PaginatedListWidget
